import { DiscountContent } from '../discount/discount-content.interface';
import { RegisteredItemProductDetails } from '../registered-item/registered-item-product-details.interface';
import { RegistrationSystemCode } from '../registration/registration-system-code.enum';
import { CmsProtectionDetailsUpsellModal } from './cms-protection-details-upsell-modal.interface';
import { ProtectionDetailsPaymentOption } from './protection-details-payment-option.interface';

export interface ProtectionDetailsUpsellModalDataWib {
  cmsProtectionDetailsUpsellModal: CmsProtectionDetailsUpsellModal;
  merchandiseBrand?: string;
  annualPlansEnabled?: boolean;
  registeredItemHasAnnualPayment: boolean;
  registeredItemAnnualProductDetails?: RegisteredItemProductDetails;
  registeredItemProducts?: RegisteredItemProductDetails[];
  systemCode: RegistrationSystemCode;
  registeredItemProductPriceDetails: number | undefined;
  protectionDetailsPaymentOptions?: ProtectionDetailsPaymentOption[];
  prepayPrice?: number;
  subscriptionPrice?: number;
  hasDiscountPrice: boolean;
  discountContent?: DiscountContent;
}
